module.exports = __webpack_public_path__ + "static/itach-hex-blue-897269a8d5a9d074da931f61cc403fef.png";